import { defineStore } from 'pinia';
import { TABLE_SETTINGS } from 'SharedDir/constants/table-settings';
import { PaginationParams } from 'SharedDir/declarations/pagination';
import { Filters } from 'PortalDir/modules/Services/composables/usePublicServicesFilters';
import { NPublicServices } from 'SharedDir/declarations/public-service';

export interface ServicesStateInterface {
  serviceList: Array<any>;
  service: NPublicServices.ServiceAbout | object;
  pagination: PaginationParams<any>;
  filters: Filters;
}
export const useServicesStore = defineStore('services', {
  state: () =>
    <ServicesStateInterface>{
      serviceList: [],
      service: {},
      pagination: {
        page: 1,
        rowsPerPage: TABLE_SETTINGS.ROWS_PER_PAGE,
        rowsNumber: 1,
        sortBy: 'id',
        descending: false,
      },
      filters: {
        groupId: null,
        name: null,
        kindId: null,
        typeId: null,
        formId: null,
        departmentId: null,
        profileTypeId: null,
        municipalAreas: [],
        segments: [],
        applicationStartsFrom: null,
        applicationStartsTo: null,
        isInformation: null,
        isOutside: null
      },
    },

  getters: {},

  actions: {
    setServiceList(value: Array<any>) {
      this.serviceList = value;
    },
    setServicePagination(value: object) {
      this.pagination = value;
    },
    setServiceFilter(value) {
      this.filters = value;
    },
    setService(value) {
      this.service = value;
    },
  },
});
